import type { ReactNode } from "react";

import { Button } from "./Button.js";
import { Modal } from "./Modal.js";

type Props = {
  open: boolean;
  title: string;
  message: ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  destructive?: boolean;
  busy?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

// Yes/No prompt built on the portal-style Modal. The confirm button uses the
// destructive `danger-sm` variant when `destructive` is true, otherwise the
// neutral `primary-sm` pill.
export function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  destructive = false,
  busy = false,
  onConfirm,
  onCancel,
}: Props) {
  return (
    <Modal open={open} onClose={onCancel} title={title} size="sm">
      <div className="text-sm text-ink-soft">{message}</div>
      <div className="mt-6 flex justify-end gap-2 border-t border-line pt-5">
        <Button variant="ghost-sm" onClick={onCancel} disabled={busy}>
          {cancelLabel}
        </Button>
        <Button
          variant={destructive ? "danger-sm" : "primary-sm"}
          onClick={onConfirm}
          disabled={busy}
        >
          {busy ? "Working…" : confirmLabel}
        </Button>
      </div>
    </Modal>
  );
}
